// Reads the verdict aloud with the browser's own voices (like the app's TTS).

const TAGS: Record<string, string> = {
  en: 'en-US', de: 'de-DE', fr: 'fr-FR', es: 'es-ES', it: 'it-IT', 'pt-BR': 'pt-BR', nl: 'nl-NL', pl: 'pl-PL',
  tr: 'tr-TR', sv: 'sv-SE', nb: 'nb-NO', cs: 'cs-CZ', hu: 'hu-HU', ro: 'ro-RO', ru: 'ru-RU', uk: 'uk-UA',
  el: 'el-GR', ar: 'ar-SA', hi: 'hi-IN', bn: 'bn-IN', id: 'id-ID', vi: 'vi-VN', ja: 'ja-JP', ko: 'ko-KR',
  'zh-CN': 'zh-CN', 'zh-TW': 'zh-TW',
};

export function speak(text: string, lang: string): void {
  try {
    const s = window.speechSynthesis;
    if (!s) return;
    s.cancel();
    const u = new SpeechSynthesisUtterance(text);
    const tag = TAGS[lang] ?? 'en-US';
    u.lang = tag;
    const voice = s.getVoices().find((v) => v.lang === tag) ?? s.getVoices().find((v) => v.lang.startsWith(tag.slice(0, 2)));
    if (voice) u.voice = voice;
    u.rate = 1.0;
    s.speak(u);
  } catch {
    // no speech on this browser
  }
}

export function stopSpeaking(): void {
  try {
    window.speechSynthesis?.cancel();
  } catch {
    // ignore
  }
}
